export default {
  AED: {
    symbol: 'د.إ'
  },
  // Emirati dirham
  AFN: {
    symbol: '؋'
  },
  // Afghan afghani
  ARS: {
    symbol: '$'
  },
  // Argentine peso
  AUD: {
    symbol: 'A$'
  },
  // Australian dollar
  BGN: {
    symbol: 'Лв.'
  },
  // Bulgarian lev
  BRL: {
    symbol: 'R$'
  },
  // Brazilian real
  CAD: {
    symbol: 'C$'
  },
  // Canadian Dollar
  CHF: {
    symbol: 'Fr.',
    right: true
  },
  // Swiss franc
  CLP: {
    symbol: '$'
  },
  // Chilean peso
  CNY: {
    symbol: '¥'
  },
  // Chinese yuan
  COP: {
    symbol: '$'
  },
  // Colombian peso
  CRC: {
    symbol: '₡'
  },
  // Costa Rican Colón
  CZK: {
    symbol: 'Kč'
  },
  // Czech koruna
  DKK: {
    symbol: 'Kr.',
    right: true
  },
  // Danish krone
  EUR: {
    symbol: '€'
  },
  // Euro
  GBP: {
    symbol: '£'
  },
  // British Pound Sterling
  HKD: {
    symbol: 'HK$'
  },
  // Honk kong dollar
  HRK: {
    symbol: 'kn'
  },
  // Croatia kuna
  HUF: {
    symbol: 'Ft'
  },
  // Hungarian forint
  IDR: {
    symbol: 'Rp'
  },
  // Rupiah
  ILS: {
    symbol: '₪'
  },
  // Israeli New Sheqel
  INR: {
    symbol: '₹'
  },
  // Indian Rupee
  JMD: {
    symbol: 'J$'
  },
  // Jamaican Dollar
  JPY: {
    symbol: '¥'
  },
  // Japanese Yen
  KRW: {
    symbol: '₩'
  },
  // South Korean Won
  MAD: {
    symbol: 'DH'
  },
  // Moroccan dirham
  MXN: {
    symbol: 'MEX$'
  },
  // Mexican peso
  MYR: {
    symbol: 'RM'
  },
  // Malaysian ringgit
  NGN: {
    symbol: '₦'
  },
  // Nigerian Naira
  NOK: {
    symbol: 'Kr.',
    right: true
  },
  // Norwegian krone
  NZD: {
    symbol: '$'
  },
  // New Zealand dollar
  PEN: {
    symbol: 'S/'
  },
  // Peruvian sol
  PHP: {
    symbol: '₱'
  },
  // Philippine Peso
  PLN: {
    symbol: 'zł',
    right: true
  },
  // Polish Zloty
  PYG: {
    symbol: '₲'
  },
  // Paraguayan Guarani
  RON: {
    symbol: 'lei'
  },
  // Romanian leu
  RUB: {
    symbol: '₽',
    right: true
  },
  // Russian ruble
  SAR: {
    symbol: 'ر.س'
  },
  // Saudi Arabian riyal
  SEK: {
    symbol: 'kr',
    right: true
  },
  // Swedish krona
  SGD: {
    symbol: '$'
  },
  // Singapore Dollar
  THB: {
    symbol: '฿'
  },
  // Thai Baht
  TRY: {
    symbol: '₺',
    right: true
  },
  // Turkish lira
  TWD: {
    symbol: 'NT$'
  },
  // New Taiwan dollar
  UAH: {
    symbol: '₴'
  },
  // Ukrainian Hryvnia
  USD: {
    symbol: '$'
  },
  // US Dollar
  VND: {
    symbol: '₫'
  },
  // Vietnamese Dong
  ZAR: {
    symbol: 'R'
  } // South african rand

};